import { useEffect, useRef, useState } from 'react';
import {
  CAMPAIGN_INBOX_STORAGE_KEY,
  CREDIT_CHART_STORAGE_KEY,
  CREDIT_CHART_TYPES,
  DEFAULT_CAMPAIGN_INBOX_CONFIG,
  DEFAULT_CREDIT_CONFIG,
  DEFAULT_MESSAGE_TYPE_CONFIG,
  LINE_PIE_TYPES,
  loadChartConfig,
  MESSAGE_TYPE_STORAGE_KEY,
  saveChartConfig,
} from '../helpers';
import { ChartConfig, ChartType } from '../types';

const usePersistentConfig = (
  key: string,
  fallback: ChartConfig,
  allowed: ChartType[],
) => {
  const [config, setConfig] = useState<ChartConfig>(() => loadChartConfig(key, fallback, allowed));
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    saveChartConfig(key, config);
  }, [key, config]);
  return [config, setConfig] as const;
};

export const useChartConfig = () => {
  const [creditChartConfig, setCreditConfig] = usePersistentConfig(
    CREDIT_CHART_STORAGE_KEY,
    DEFAULT_CREDIT_CONFIG,
    CREDIT_CHART_TYPES,
  );
  const [messageTypeConfig, setMessageTypeConfig] = usePersistentConfig(
    MESSAGE_TYPE_STORAGE_KEY,
    DEFAULT_MESSAGE_TYPE_CONFIG,
    LINE_PIE_TYPES,
  );
  const [campaignInboxConfig, setCampaignInboxConfig] = usePersistentConfig(
    CAMPAIGN_INBOX_STORAGE_KEY,
    DEFAULT_CAMPAIGN_INBOX_CONFIG,
    LINE_PIE_TYPES,
  );

  return {
    creditChartConfig,
    messageTypeConfig,
    campaignInboxConfig,
    setCreditChartType: (type: ChartType) => setCreditConfig({ type }),
    setMessageTypeType: (type: ChartType) => setMessageTypeConfig({ type }),
    setCampaignInboxType: (type: ChartType) => setCampaignInboxConfig({ type }),
  };
};
